export const isNotificationSupported = () => 'Notification' in window;

export const getNotificationPermission = () => Notification.permission;

const isNotificationPromiseSupported = () => {
  try {
    Notification.requestPermission().then();
  } catch (e) {
    return false;
  }

  return true;
};

export const requestNotificationPermissions = async () => {
  if (Notification.permission === 'denied') {
    throw new Error('Permissions denied');
  }

  if (Notification.permission !== 'granted') {
    if (isNotificationPromiseSupported()) {
      const permission = await Notification.requestPermission();

      if (permission !== 'granted') {
        throw new Error('Permissions denied');
      }
    } else {
      Notification.requestPermission((permission) => {
        if (permission !== 'granted') {
          throw new Error('Permissions denied');
        }
      });
    }
  }
};
